import styles from "./Locais.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Button from "../../../../components/components-ui/Button/Button";
import Modal from "../../../../components/Modal";
import { Grid, Col } from "../../../../components/Grid";
import { Table } from "../../../../components/Table";
import { InputMasked } from "../../../../components/components-ui/InputMask/InputMask";
import api from "../../../../services/Api";
import { ModalBrinde } from "./Modal";
import * as Yup from "yup";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState, useRef, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
//
import Coletas from "./Tabs/Coletas";
import Ligacao from "./Tabs/Ligacao";
import Relacionamento from "./Tabs/Relacionamento";
import Materiais from "./Tabs/Materiais";
import { Box } from "@mui/material";
import DatePicker from "../../../../components/components-ui/DatePicker/DatePicker";
import Loading from "../../../../components/components-ui/Loading/Loading";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import * as Sentry from "@sentry/react";
import { AuthContext } from "../../../../Provider/AuthContext";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";
//

// LINKS
const API_DADOS_LOCAL = `/local/show/`;
const API_CIDADES = `/cidade/index`;
const API_GRUPOS = `/grupo/index`;
const API_CAMPANHAS = `/campanha/index`;
const API_ESTABELECIMENTO = `/estabelecimento/index`;
const API_STATUS = `/local/status/index`;
const API_PERIODICIDADE = "/local/periodicidade";
const API_FORMA_DE_PAGAMENTO = "/formadepagamento";
const API_TIPO_CONTRAPARTIDA = "/tipocontrapartida/index";
const API_TIPO_PIX = "/tipochavepix/index";
const API_PREPOSTO = "/preposto/index";
const API_CAPTACAO = "/usuario/view";
const API_ORIGEM = `/origem/index`;
const API_LISTA_PREFERENCIA_CONTATO = `/preferenciacontato/index`;
const API_LOGRADOURO = `/logradourotipo/index`;
const API_LISTA_ENTIDADE = `/entidademtr`;
const API_DATA_USUARIO = "/coleta/new";
const API_VALIDA_CNPJ = "/local/validacnpj/";

export default function PainelLocal() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const { id } = useParams();
  const [dadosLocal, setDadosLocal] = useState([]);
  const [cidade, setCidade] = useState([]);
  const [grupo, setGrupo] = useState([]);
  const [campanha, setCampanha] = useState([]);
  const [estabelecimento, setEstabelecimento] = useState([]);
  const [status, setStatus] = useState([]);
  const [periodicidade, setPeriodicidade] = useState([]);
  const [formaDePagamento, setFormaDePagamento] = useState([]);
  const [preposto, setPreposto] = useState([]);
  const [tipoContrapartida, setTipoContrapartida] = useState([]);
  const [captacao, setCaptacao] = useState([]);
  const [preferenciaContato, setPreferenciaContato] = useState([]);
  const [origem, setOrigem] = useState([]);
  const [tipoLogradouro, setTipoLogradouro] = useState([]);
  const [tipoPix, setTipoPix] = useState([]);
  const [conta, setConta] = useState([]);
  const [entidade, setEntidade] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [dadosUsuario, setDadosUsuario] = useState([]);
  const [block, setBlock] = useState(false);
  const [tipoCadastro, setTipoCadastro] = useState("");
  const [blockBtnBanco, setBlockBtnBanco] = useState(false);
  const inputCnpjRef = useRef(null);
  const [isRequired, setIsRequired] = useState({
    tipoLogradouro: true,
    cidade: true,
  });
  const [dataCriacao, setDataCriacao] = useState("");

  // Dados relacionado ao modal
  const [openModalBrinde, setOpenModalBrinde] = useState(false);
  const [dadosModalBrinde, setDadosModalBrinde] = useState([]);
  const [dadosModalBrindeAPI, setDadosModalBrindeAPI] = useState([]);
  const nomeLocalRef = useRef();
  const navigate = useNavigate();

  // ALERT PERSONALIZADO
  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
  }

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela locais
    verificaPermissao(idTipoUsuario, 39);
  }, []);

  // CARREGA LISTA DE BRINDES DE ACORDO COM O USUARIO
  async function getListaBrinde() {
    if (id) {
      const response = await api.get(`/local/show/${id}`);
      return setDadosModalBrindeAPI(response.data.brinde);
    }
  }
  // Renderiza dados do formulário
  useEffect(() => {
    setLoading(true); // Ativa o loading até os dados carregarem por completo
    if (id) {
      async function getApiDadosLocal() {
        const response = await api.get(`${API_DADOS_LOCAL}${id}`);
        const cpfOuCnpj = response.data.local?.IdTipoCadastro;
        setTipoCadastro(cpfOuCnpj);
        setDataCriacao(response.data.local?.Audit_DataCriacao);
        setDadosLocal(response.data.local);
        setConta(response.data.conta[0]); // Atribui os dados da compra para a variavel
        setLoading(false); // Desativa o loading com os dados carregados
      }
      getApiDadosLocal();
    }

    // Carregar Cidades
    async function getCidade() {
      const response = await api.get(API_CIDADES);
      setCidade(response.data);
      return;
    }
    getCidade();
    // Carregar Grupos
    async function getGrupo() {
      const response = await api.get(API_GRUPOS);
      setGrupo(response.data);
      return;
    }
    getGrupo();
    // Carregar Campanhas
    async function getCampanha() {
      const response = await api.get(API_CAMPANHAS);
      setCampanha(response.data);
      return;
    }
    getCampanha();
    // Carregar Estabelecimento
    async function getEstabelecimento() {
      const response = await api.get(API_ESTABELECIMENTO);
      setEstabelecimento(response.data);
      return;
    }
    getEstabelecimento();

    // Carregar Status
    async function getStatus() {
      const response = await api.get(API_STATUS);
      setStatus(response.data);
      return;
    }
    getStatus();

    // Carregar Peridiocidade
    async function getPeriodicidade() {
      const response = await api.get(API_PERIODICIDADE);
      setPeriodicidade(response.data);
      return;
    }
    getPeriodicidade();

    // Carregar Forma de Pagamento
    async function getFormaDePagamento() {
      const response = await api.get(API_FORMA_DE_PAGAMENTO);
      setFormaDePagamento(response.data);
      return;
    }
    getFormaDePagamento();

    // Carregar Preposto
    async function getPreposto() {
      const response = await api.get(API_PREPOSTO);
      setPreposto(response.data);
      return;
    }
    getPreposto();

    // Carregar Tipo de Contrapartida
    async function getTipoContrapartida() {
      const response = await api.get(API_TIPO_CONTRAPARTIDA);
      setTipoContrapartida(response.data);
    }
    getTipoContrapartida();

    // Carregar Origens
    async function getOrigem() {
      const response = await api.get(API_ORIGEM);
      setOrigem(response.data);
      return;
    }
    getOrigem();

    // Carregar Preferência Contato
    async function getPreferenciaContato() {
      const response = await api.get(API_LISTA_PREFERENCIA_CONTATO);
      setPreferenciaContato(response.data);
      return;
    }
    getPreferenciaContato();

    // Carregar Captacao
    async function getCaptacao() {
      const response = await api.get(API_CAPTACAO);
      setCaptacao(response.data);
      return;
    }
    getCaptacao();

    // Carregar Tipo Logradouro
    async function getTipoLogradouro() {
      const response = await api.get(API_LOGRADOURO);
      setTipoLogradouro(response.data);
      return;
    }

    getTipoLogradouro(API_LOGRADOURO);
    // Carrega brindes
    getListaBrinde();

    //
    async function getEntidade() {
      const response = await api.get(API_LISTA_ENTIDADE);
      return setEntidade(response.data);
    }
    getEntidade();

    //Busca id usuario e data do dia
    async function getDadosUsuario() {
      const response = await api.get(API_DATA_USUARIO);
      setDadosUsuario(response.data);
    }
    getDadosUsuario();

    //Carrega Pix
    async function getTipoPix() {
      const response = await api.get(API_TIPO_PIX);
      setTipoPix(response.data.data);
    }
    getTipoPix();

    // nomeLocalRef.current.focus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPressEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  // EDIÇÃO DE LOCAL
  async function editarLocal(values) {
    const dadosFormulario = {
      id_local: values.idLocal,
      nome_local: values.nomeLocal?.toUpperCase(),
      Marca: values.marca?.toUpperCase(),
      cnpj_cpf: values.cnpjCpf.replace(/[.\-/]/g, ""),
      id_tipo_cadastro: Number(values?.tipoCadastro),
      InscricaoEstadual:
        tipoCadastro == 1 ? values.inscricaoEstadual?.toUpperCase() : "",
      id_status: values.status,
      cep: values.cep,
      id_tipo_logradouro: values.tipoLogradouro,
      logradouro: values.logradouro?.toUpperCase(),
      numero: values.numero,
      complemento: values.complemento?.toUpperCase(),
      bairro: values.bairro?.toUpperCase(),
      id_cidade: values.cidade,
      uf: values.uf?.toUpperCase(),
      id_campanha: values.campanha,
      data_positivacao: values.dataPositivacao,
      bombas: values.bombas,
      id_grupo: values.grupo,
      id_captacao: values.captacao,
      id_estabelecimento: values.tEstabelecimento,
      idOrigem: values.origem,
      id_preferencia_contato: values.preferenciaContato,
      Email: values.email?.toUpperCase(),
      data_cadastro: values.dataCadastro,
      nome_contato: values.nomeContato?.toUpperCase(),
      telefones: values.telefones,
      data_inativacao: values.dataInativacao,
      observacao: values.observacao?.toUpperCase(),
      Freguesia: values.freguesia,
      Retirada01: values.retirada.retirada01,
      Retirada02: values.retirada.retirada02,
      Retirada03: values.retirada.retirada03,
      IdPeriodicidade: values.periodicidade,
      IdFormaPagamento: values.pagamento,
      IdPreposto: values.preposto,
      IdTipoContrapartida: values.tipoContrapartida,
      ValorKgContrapartida: values.valorKgContrapartida || null,
      brinde: values.observacao,
      Analista: values.analista?.toUpperCase(),
      Audit_IdUsuarioCriacao: values.usuarioCriacao,
      Audit_IdUsuarioAlteracao: dadosUsuario?.user_id,
      Audit_DataCriacao: values.dataCriacao,
      Audit_DataAlteracao: dadosUsuario?.data_pedido,
    };
    const brinde = {
      ...dadosModalBrindeAPI,
    };
    const data = {
      dadosFormulario: dadosFormulario,
      dadosBrinde: brinde,
      dadosBanco: {
        IdLocal: values.idLocal,
        Banco: values.banco,
        IdTipoPessoa: values.tipoPessoa,
        cnpjcpf: values.cpfCnpjBanco,
        NomeFavorecido: values.favorecido,
        IdTipoConta: values.tipoConta,
        NumeroAgencia: values.agencia,
        NumeroConta: values.numeroConta,
        IdTipoChavePix: values.tipoChavePix,
        NumeroPix: values.numeroPix,
      },
    };
    // showAlert(0, 'Local Editado')
    console.log(data);
    const response = await api
      .put(`/local/editcombanco/${id}`, data)
      .then((e) => {
        if (e.data.error === 0) {
          toast.success(e.data.msg, { position: "bottom-right" });
          navigate("/usina/local");
          return;
        }
        toast.warn(e.data.msg);
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
        Sentry.captureException(e, {
          extra: {
            response: e.response?.data.message,
            status: e.response?.status,
            url: `/local/edit/${id}`,
            payload: data,
          },
        });
      });

    // if (response.data.error === 0) {
    //   showAlert(0, response.data.msg)
    //   return
    // }
    // showAlert(1, response.data.msg)
  }
  // CRIAR NOVO LOCAL
  async function criarLocal(values) {
    console.log(values);
    const dadosFormulario = {
      id_local: values.idLocal,
      nome_local: values.nomeLocal?.toUpperCase(),
      Marca: values.marca?.toUpperCase(),
      cnpj_cpf: values.cnpjCpf.replace(/[.\-/]/g, ""),
      id_tipo_cadastro: Number(values?.tipoCadastro),
      InscricaoEstadual:
        tipoCadastro == 1 ? values.inscricaoEstadual?.toUpperCase() : "",
      id_status: values.status,
      cep: values.cep,
      id_tipo_logradouro: values.tipoLogradouro,
      logradouro: values.logradouro?.toUpperCase(),
      numero: values.numero,
      complemento: values.complemento?.toUpperCase(),
      bairro: values.bairro?.toUpperCase(),
      id_cidade: values.cidade,
      uf: values.uf?.toUpperCase(),
      id_campanha: values.campanha,
      data_positivacao: values.dataPositivacao,
      bombas: values.bombas,
      id_grupo: values.grupo,
      id_captacao: values.captacao,
      id_estabelecimento: values.tEstabelecimento,
      idOrigem: values.origem,
      id_preferencia_contato: values.preferenciaContato,
      Email: values.email?.toUpperCase(),
      data_cadastro: values.dataCadastro,
      nome_contato: values.nomeContato?.toUpperCase(),
      telefones: values.telefones,
      data_inativacao: values.dataInativacao,
      observacao: values.observacao?.toUpperCase(),
      Freguesia: values.freguesia,
      Retirada01: values.retirada.retirada01,
      Retirada02: values.retirada.retirada02,
      Retirada03: values.retirada.retirada03,
      IdPeriodicidade: values.periodicidade,
      IdFormaPagamento: values.pagamento,
      IdPreposto: values.preposto,
      IdTipoContrapartida: values.tipoContrapartida,
      ValorKgContrapartida: values.valorKgContrapartida || null,
      brinde: values.observacao,
      Analista: values.analista?.toUpperCase(),
      Audit_IdUsuarioCriacao: values.usuarioCriacao,
      Audit_IdUsuarioAlteracao: values.usuarioAlteracao,
      Audit_DataCriacao: values.dataCriacao,
      Audit_DataAlteracao: values.dataAlteracao,
    };
    const data = {
      dadosFormulario: dadosFormulario,
      dadosBrinde: dadosModalBrinde,
      dadosBanco: {
        IdLocal: values.idLocal,
        Banco: values.banco,
        IdTipoPessoa: values.tipoPessoa,
        cnpjcpf: values.cpfCnpjBanco,
        NomeFavorecido: values.favorecido,
        IdTipoConta: values.tipoConta,
        NumeroAgencia: values.agencia,
        NumeroConta: values.numeroConta,
        IdTipoChavePix: values.tipoChavePix,
        NumeroPix: values.numeroPix,
      },
    };
    // console.log(dadosModalBrinde)
    console.log(data);
    const response = await api
      .post(`/local/createcombanco`, {
        data,
      })
      .then((e) => {
        if (e.data.error === 0) {
          toast.success("Local criado com sucesso!", {
            position: "bottom-right",
          });
          navigate("/usina/local");
          return;
        }
        toast.warn(e.data.msg);
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
        Sentry.captureException(e, {
          extra: {
            response: e.response?.data.message,
            status: e.response?.status,
            url: `/local/create`,
            payload: data,
          },
        });
      });
    // if (response.data.error === 0) {
    //   return showAlert(0, response.data.msg)
    // }
    // showAlert(1, response.data.msg)
  }
  // PREENCHIMENTO AUTOMATICO DE ENDERECO
  async function handleCep(ev, setFieldValue) {
    setFieldValue("cep", ev.value);
    const value = ev.value.replace(/[^0-9]/g, "");
    if (value.length >= 8) {
      const response = await api.get(`/local/buscacep/${value}`);
      if (response.data.error === 0) {
        setFieldValue("uf", response.data.data.uf);
        setFieldValue(
          "cidade",
          response.data.data.idCidade
            ? response.data.data.idCidade
            : setIsRequired((prevState) => ({ ...prevState, cidade: false }))
        );
        setFieldValue(
          "tipoLogradouro",
          response.data.data.idTipoLogradouro
            ? response.data.data.idTipoLogradouro
            : setIsRequired((prevState) => ({
                ...prevState,
                tipoLogradouro: false,
              }))
        );
        setFieldValue("bairro", response.data.data.bairro);
        setFieldValue("logradouro", response.data.data.logradouro);
      } else {
        toast.warn(response.data.msg);
      }
      return;
    }
  }
  const columnsBrinde = [
    {
      column: "Nome Brinde",
    },
  ];
  // Inserção de brinde Local
  function adicionaBrindeLocalmente(values) {
    for (let i = 0; i < dadosModalBrinde.length; i++) {
      if (dadosModalBrinde[i].brinde === values.brinde) {
        //  window.alert('Item já adicionado')
        return confirmAlert({
          title: "Brinde já está na cadastrado para esse local.",
          buttons: [
            {
              label: "Fechar",
            },
          ],
        });
      }
    }
    confirmAlert({
      title: "Brinde cadastrado com sucesso.",
      buttons: [
        {
          label: "Fechar",
        },
      ],
    });
    setDadosModalBrinde([...dadosModalBrinde, values]);
  }
  // Deleção de brinde Local
  async function deletarBrindeLocal(id_brinde, arr) {
    let response = confirmAlert({
      title: "Tem certeza que deseja excluir esse brinde ?",
      buttons: [
        {
          label: "Confirmar",
        },
        {
          label: "Cancelar",
        },
      ],
    });
    let res = await response;
    // let response = window.confirm(
    //   'Tem certeza que deseja excluir esse brinde ?'
    // )
    if (res[0]) {
      arr.forEach((item, index) => {
        if (index === id_brinde) {
          arr.splice(id_brinde, 1);
          confirmAlert({
            title: "Brinde excluído com sucesso.",
            buttons: [
              {
                label: "Fechar",
              },
            ],
          });
          setDadosModalBrinde([...dadosModalBrinde]);
        }
      });
    }
    return;
  }
  // inserção de brinde na api
  async function adicionaBrindeAPI(values) {
    const response = await api.post("/local/edit/brinde/create", values);
    // setUpdateTableBrinde(!updateTableBrinde)
    getListaBrinde();
    confirmAlert({
      title: response.data.status_msg,
      buttons: [
        {
          label: "Fechar",
        },
      ],
    });
    // window.alert(response.data.status_msg)
  }
  // Deleção direto na api
  async function deletarBrindeApi(id_local_brinde) {
    let response = confirmAlert({
      title: "Tem certeza que deseja excluir esse brinde ?",
      buttons: [
        {
          label: "Confirmar",
        },
        {
          label: "Cancelar",
        },
      ],
    });
    let res = await response;

    // let response = window.confirm('Tem certeza que deseja excluir esse brinde')
    if (res[0]) {
      const data = { id_local: id };
      const response = await api.delete(
        `/local/edit/brinde/delete/${id_local_brinde}`,
        { data }
      );

      // window.alert(response.data.status_msg)
      confirmAlert({
        title: response.data.status_msg,
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
      getListaBrinde();
      // setUpdateTableBrinde(!updateTableBrinde)
      return;
    }
  }

  // Limpar cnpj ao mudar o tipo
  function handleChangeTipo(setFieldValue, tipoCadastro) {
    console.log(tipoCadastro);

    if (inputCnpjRef.current) {
      inputCnpjRef.current.focus();
    }

    if (tipoCadastro == 2) {
      setFieldValue("inscricaoEstadual", "");
    }

    setFieldValue("tipoCadastro", tipoCadastro);
    setTipoCadastro(tipoCadastro);
    setFieldValue("cnpjCpf", "");
  }

  // Valida CNPJ/CPF
  async function validaCnpj(value, tipo, setFieldValue) {
    const cnpjCpf = value.replace(/[.\-/]/g, "");

    if (
      (tipo == 1 && cnpjCpf.length < 14) || //CNPJ
      (tipo == 2 && cnpjCpf.length < 11) // CPF
    ) {
      setFieldValue("cnpjCpf", "");
      return;
    }

    if (!id) {
      await api
        .get(`${API_VALIDA_CNPJ}${tipo}/${cnpjCpf}`)
        .then((res) => {
          if (res.data.error === 1) {
            toast.warn(res.data.msg);
            // setBlock(true);
            return;
          }
          // setBlock(false);
        })
        .catch((error) => console.log(error));
    }
  }

  //Variaveis para teste do banco
  const columnsBanco = [
    {
      column: "Nome banco",
    },
    {
      column: "Nº agência",
    },
    {
      column: "Nº Conta",
    },
    {
      column: "Nome Favorecido",
    },
    {
      column: "CPF/CNPJ",
    },
  ];

  const testeVariosBancos = [
    {
      IdLocal: 1,
      Banco: "Itau",
      IdTipoPessoa: null,
      cnpjcpf: "12312424214",
      NomeFavorecido: "ARCOS DOURADOS COM.DE ALIMENTO",
      IdTipoConta: null,
      NumeroAgencia: 3213,
      NumeroConta: "2314252515515",
      IdTipoChavePix: null,
    },
    {
      IdLocal: 2,
      Banco: "Bradesco",
      IdTipoPessoa: null,
      cnpjcpf: "3333.3333.3333/22",
      NomeFavorecido: "ARCOS DOURADOS COM.DE ALIMENTO",
      IdTipoConta: null,
      NumeroAgencia: 2134,
      NumeroConta: "21324512552",
      IdTipoChavePix: null,
    },
    {
      IdLocal: 3,
      Banco: "Nubank",
      IdTipoPessoa: null,
      cnpjcpf: "2222.2222.2222/22",
      NomeFavorecido: "ARCOS DOURADOS COM.DE ALIMENTO",
      IdTipoConta: null,
      NumeroAgencia: 4214,
      NumeroConta: "32523525352",
      IdTipoChavePix: null,
    },
    {
      IdLocal: 4,
      Banco: "Santander",
      IdTipoPessoa: null,
      cnpjcpf: "1111.1111.111",
      NomeFavorecido: "ARCOS DOURADOS COM.DE ALIMENTO",
      IdTipoConta: null,
      NumeroAgencia: 2331,
      NumeroConta: "41255523213",
      IdTipoChavePix: null,
    },
  ];

  async function adicionaBanco(values) {
    const dadosBanco = {
      IdLocal: values.idLocal,
      Banco: values.banco,
      IdTipoPessoa: values.tipoPessoa,
      cnpjcpf: values.cpfCnpjBanco,
      NomeFavorecido: values.favorecido,
      IdTipoConta: values.tipoConta,
      NumeroAgencia: values.agencia,
      NumeroConta: values.numeroConta,
      IdTipoChavePix: values.tipoChavePix,
      NumeroPix: values.numeroPix,
    };

    if (!id) {
      return confirmAlert({
        title: "Erro!",
        message:
          "Para adicionar o banco é necessário primeiramente criar o local. Após criado adicione o banco na tela de edição.",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    }

    setBlockBtnBanco(true);
    const response = await api
      .post("/local/createcontacorrente", dadosBanco)
      .then((e) => {
        if (e.status == 0) {
          toast.success("Banco adicionado com sucesso");
          return;
        }
        toast.success("Banco editado!");
      })
      .catch(() => toast.error("Houve algum problema ao adicionar o banco"))
      .finally(() => setBlockBtnBanco(false));
    return response;
  }

  function verificaMascaraInput(value) {
    if (value && value[0].match(/\d/)) return true;
  }

  const validateYear =
    new Date(dadosLocal?.Audit_DataCriacao).getFullYear() < 2025;

  const ValidationSchema = Yup.object().shape({
    idLocal: Yup.string(),
    nomeLocal: Yup.string()
      .nullable()
      .required("O campo nome local é obrigatório"),
    marca: Yup.string().nullable().required("Campo obrigatório"),
    status: Yup.string().nullable().required("Campo obrigatório"),
    cnpjCpf: Yup.string().nullable().required("Campo obrigatório"),
    inscricaoEstadual:
      validateYear || tipoCadastro == 2
        ? Yup.string().nullable()
        : Yup.string().nullable().required("Campo obrigatório"),
    preposto: Yup.string().nullable().required("Campo obrigatório"),
    tipoCadastro: Yup.string().nullable().required("Campo obrigatório"),
    freguesia: Yup.string().nullable().required("Campo obrigatório"),
    retirada: Yup.object()
      .shape({
        retirada01: Yup.string().nullable(),
        retirada02: Yup.string().nullable(),
        retirada03: Yup.string().nullable(),
      })
      .test(
        "deve haver pelo menos uma retirada",
        "Preencha uma retirada",
        function (value) {
          return !!(
            value?.retirada01 ||
            value?.retirada02 ||
            value?.retirada03
          );
        }
      ),
    periodicidade: Yup.number().nullable().required("Campo obrigatório"),
    cep: Yup.string().nullable().required("Campo obrigatório"),
    tipoLogradouro: isRequired.tipoLogradouro
      ? Yup.string().nullable().required("Campo obrigatório")
      : Yup.string().nullable(),
    logradouro: Yup.string().nullable().required("Campo obrigatório"),
    numero: Yup.number().positive("*Campo Obrigatório").nullable(),
    complemento: Yup.string().nullable(),
    bairro: Yup.string().nullable().required("Campo obrigatório"),
    cidade: isRequired.cidade
      ? Yup.number().nullable().required("Campo obrigatório")
      : Yup.number().nullable(),
    uf: Yup.string().nullable().required("Campo obrigatório"),
    pagamento: Yup.number().nullable().required("Campo obrigatório"),
    valorKgContrapartida: Yup.number().nullable().required("Campo obrigatório"),
    campanha: Yup.string().nullable(),
    dataPositivacao: Yup.string().nullable(),
    bombas: Yup.string().nullable(),
    grupo: Yup.string().nullable(),
    captacao: Yup.string().nullable().required("Campo Obrigatório"),
    tEstabelecimento: Yup.string().nullable(),
    origem: !id
      ? Yup.string().nullable().required("Campo Obrigatório")
      : Yup.string().nullable(),
    preferenciaContato: Yup.string().nullable(),
    email: Yup.string().nullable(),
    dataCadastro: Yup.string().nullable(),
    nomeContato: validateYear
      ? Yup.string().nullable()
      : Yup.string().nullable().required("Campo obrigatório"),
    telefones: validateYear
      ? Yup.string().nullable()
      : Yup.string().nullable().required("Campo obrigatório"),
    dataInativacao: Yup.date().nullable(),
    observacao: Yup.string().nullable(),
    emiteMTR: Yup.bool(),
    entidadeMTR: Yup.string(),
    login: Yup.string(),
    senha: Yup.string(),
    unidade: Yup.string(),
  });

  return (
    <Container>
      <h3> {id ? "Edição de Local" : "Novo Local"} </h3>
      <section className={styles.content}>
        <Formik
          initialValues={{
            idLocal: id ? dadosLocal?.id_local : "Novo",
            nomeLocal: dadosLocal?.nome_local || "",
            marca: dadosLocal?.Marca || "",
            cnpjCpf: dadosLocal?.cnpj_cpf || "",
            inscricaoEstadual: dadosLocal?.InscricaoEstadual || "",
            status: dadosLocal?.id_status ? dadosLocal?.id_status : 3,
            cep: dadosLocal?.cep || "",
            tipoLogradouro: dadosLocal?.id_tipo_logradouro || "",
            logradouro: dadosLocal?.logradouro || "",
            numero: dadosLocal?.numero || "",
            complemento: dadosLocal?.complemento || "",
            bairro: dadosLocal?.bairro || "",
            cidade: dadosLocal?.id_cidade || null,
            uf: dadosLocal?.uf || "",
            campanha: dadosLocal?.id_campanha || null,
            dataPositivacao: dadosLocal?.data_positivacao || "",
            bombas: dadosLocal?.bombas || "",
            grupo: dadosLocal?.id_grupo || null,
            captacao: dadosLocal?.id_captacao || null,
            tEstabelecimento: dadosLocal?.id_estabelecimento || null,
            origem: dadosLocal?.idOrigem || null,
            preferenciaContato: dadosLocal?.id_preferencia_contato || null,
            email: dadosLocal?.Email || "",
            dataCadastro: dadosLocal?.data_cadastro || "",
            nomeContato: dadosLocal?.nome_contato || "",
            telefones: dadosLocal?.telefones || "",
            dataInativacao: dadosLocal?.data_inativacao || "",
            observacao: dadosLocal?.observacao || "",
            freguesia: dadosLocal?.Freguesia || "",
            retirada: {
              retirada01: dadosLocal?.Retirada01 || "",
              retirada02: dadosLocal?.Retirada02 || "",
              retirada03: dadosLocal?.Retirada03 || "",
            },
            periodicidade: dadosLocal?.IdPeriodicidade || null,
            pagamento: dadosLocal?.IdFormaPagamento || null,
            tipoContrapartida: dadosLocal?.IdTipoContrapartida || null,
            valorKgContrapartida: dadosLocal?.ValorKgContrapartida
              ? parseFloat(dadosLocal?.ValorKgContrapartida).toFixed(2)
              : null,
            preposto: dadosLocal?.IdPreposto || 1,
            tipoCadastro: dadosLocal?.IdTipoCadastro
              ? dadosLocal?.IdTipoCadastro
              : "",
            analista: dadosLocal?.Analista || "",
            usuarioCriacao: dadosLocal?.IdUsuarioCriacao
              ? dadosLocal?.IdUsuarioCriacao
              : dadosUsuario?.user_id,
            usuarioAlteracao: dadosLocal?.IdUsuarioAlteracao
              ? dadosLocal?.IdUsuarioAlteracao
              : null,
            dataCriacao: dadosLocal?.Audit_DataCriacao
              ? dadosLocal?.Audit_DataCriacao
              : dadosUsuario?.data_pedido,
            dataAlteracao: dadosLocal?.Audit_DataAlteracao
              ? dadosLocal?.Audit_DataAlteracao
              : null,
            emitemtr: dadosLocal?.emitemtr || "",
            entidadeMTR: "",
            login: "",
            senha: "",
            unidade: "",
            banco: conta?.Banco || null,
            tipoPessoa: conta?.IdTipoPessoa || null,
            cpfCnpjBanco: conta?.cnpjcpf || null,
            favorecido: conta?.NomeFavorecido || null,
            tipoConta: conta?.IdTipoConta || null,
            agencia: conta?.NumeroAgencia || null,
            numeroConta: conta?.NumeroConta || null,
            tipoChavePix: conta?.IdTipoChavePix || null,
            numeroPix: conta?.NumeroPix || null,
          }}
          enableReinitialize={true}
          validationSchema={ValidationSchema}
          validateOnBlur
          validateOnChange
          onSubmit={(values) => (id ? editarLocal(values) : criarLocal(values))}
        >
          {({ errors, touched, setFieldValue, values, isSubmitting }) => (
            <Form onKeyDown={onPressEnter}>
              <Tabs forceRenderTabPanel={true}>
                <TabList>
                  <Tab>Dados do Local</Tab>
                  <Tab>Coletas</Tab>
                  <Tab>Contrapartida | MTR</Tab>
                  <Tab>Ligações</Tab>
                  <Tab>Relacionamento</Tab>
                  <Tab>Materiais</Tab>
                </TabList>
                <TabPanel>
                  {isLoading && id ? (
                    <div className={styles.loading}>
                      <Loading />
                    </div>
                  ) : (
                    <>
                      <Grid>
                        <Col size={1}>
                          <label> ID Local </label>
                          <Field type="text" name="idLocal" disabled />
                          {errors.idLocal && touched.idLocal ? (
                            <span className={styles.alertError}>
                              {errors.idLocal}
                            </span>
                          ) : null}
                        </Col>

                        <Col size={4}>
                          <label> Nome Local </label>
                          <Field name="nomeLocal">
                            {({ field }) => (
                              <input
                                type="text"
                                ref={nomeLocalRef}
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                          {errors.nomeLocal && touched.nomeLocal ? (
                            <span className={styles.alertError}>
                              {errors.nomeLocal}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={4}>
                          <label>Marca</label>
                          <Field name="marca">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                          {errors.marca && touched.marca ? (
                            <span className={styles.alertError}>
                              {errors.marca}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label>Status</label>
                          <Field
                            name="status"
                            component={SelectSearch}
                            options={status.map((values) => ({
                              value: values?.idstatus,
                              label: values?.Status,
                            }))}
                          />
                          {errors.status && touched.status ? (
                            <span className={styles.alertError}>
                              {errors.status}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>
                      <Grid>
                        <Col size={1}>
                          <label style={{ whiteSpace: "nowrap" }}>
                            Preposto Sigla
                          </label>
                          <Field
                            component="select"
                            name="preposto"
                            // options={preposto.map((values) => ({
                            //   label: values?.RazaoSocial,
                            //   value: values?.IdPreposto,
                            // }))}
                          >
                            <option value={null}>Selecione</option>
                            {preposto.map((values) => (
                              <option value={values?.IdPreposto}>
                                {values?.RazaoSocial}
                              </option>
                            ))}
                          </Field>
                          {errors.preposto && touched.preposto ? (
                            <span className={styles.alertError}>
                              {errors.preposto}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={1}>
                          <label> Tipo Cadastro </label>
                          <Field
                            component="select"
                            name="tipoCadastro"
                            value={values.tipoCadastro}
                            onChange={(e) =>
                              handleChangeTipo(setFieldValue, e.target.value)
                            }
                          >
                            <option value={""} disabled>
                              Selecione
                            </option>
                            <option value={1}>CNPJ</option>
                            <option value={2}>CPF</option>
                          </Field>
                          {errors.tipoCadastro && touched.tipoCadastro ? (
                            <span className={styles.alertError}>
                              {errors.tipoCadastro}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label>
                            {values.tipoCadastro == ""
                              ? "CNPJ/CPF"
                              : values.tipoCadastro == 1
                              ? "CNPJ"
                              : "CPF"}
                          </label>
                          <Field name="cnpjCpf" maxLength={14}>
                            {({ field }) => (
                              <InputMasked
                                {...field}
                                ref={inputCnpjRef}
                                mask={
                                  values.tipoCadastro == 1
                                    ? "99.999.999/9999-99"
                                    : "999.999.999-99"
                                }
                                maskChar=""
                                onBlur={() =>
                                  validaCnpj(
                                    values.cnpjCpf,
                                    tipoCadastro,
                                    setFieldValue
                                  )
                                }
                                disabled={values.tipoCadastro == ""}
                              />
                            )}
                          </Field>
                          {errors.cnpjCpf && touched.cnpjCpf ? (
                            <span className={styles.alertError}>
                              {errors.cnpjCpf}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> Inscrição Estadual </label>
                          <Field name="inscricaoEstadual">
                            {({ field }) => (
                              <InputMasked
                                {...field}
                                mask={
                                  verificaMascaraInput(field.value)
                                    ? "999.999.999.999"
                                    : ""
                                }
                                maskChar=""
                                disabled={
                                  values.tipoCadastro == 2 || // Desativado caso seja cpf
                                  values.tipoCadastro == ""
                                }
                                className={styles.input_style}
                              />
                            )}
                          </Field>
                          {errors.inscricaoEstadual &&
                          touched.inscricaoEstadual ? (
                            <span className={styles.alertError}>
                              {errors.inscricaoEstadual}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={1}>
                          <label> Freguesia </label>
                          <Field name="freguesia">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                          {errors.freguesia && touched.freguesia ? (
                            <span className={styles.alertError}>
                              {errors.freguesia}
                            </span>
                          ) : null}
                        </Col>

                        <Col size={1}>
                          <label>Retirada 1</label>
                          <Field name="retirada.retirada01">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                          {errors.retirada && touched.retirada ? (
                            <span className={styles.alertError}>
                              {errors.retirada}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={1}>
                          <label>Retirada 2</label>
                          <Field name="retirada.retirada02">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                        </Col>
                        <Col size={1}>
                          <label>Retirada 3</label>
                          <Field name="retirada.retirada03">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                        </Col>
                        <Col size={2}>
                          <label>Periodicidade</label>
                          <Field
                            name="periodicidade"
                            component={SelectSearch}
                            options={periodicidade.map((values) => ({
                              value: values?.Id,
                              label: values?.Periodicidade,
                            }))}
                          />
                          {errors.periodicidade && touched.periodicidade ? (
                            <span className={styles.alertError}>
                              {errors.periodicidade}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>

                      <Grid>
                        <Col size={2}>
                          <label> CEP </label>
                          <Field name="cep">
                            {({ field }) => (
                              <InputMasked
                                {...field}
                                mask="99999-999"
                                onChange={(ev) =>
                                  handleCep(ev.target, setFieldValue)
                                }
                              />
                            )}
                          </Field>
                          {/* <Field name="cep"/> */}
                          {errors.cep && touched.cep ? (
                            <span className={styles.alertError}>
                              {errors.cep}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> Tipo </label>
                          <Field
                            name="tipoLogradouro"
                            component={SelectSearch}
                            options={tipoLogradouro.map((values) => ({
                              value: values?.IDTipoLogradouro,
                              label: values?.TipoLogradouro,
                            }))}
                          />
                          {errors.tipoLogradouro && touched.tipoLogradouro ? (
                            <span className={styles.alertError}>
                              {errors.tipoLogradouro}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={4}>
                          <label> Logradouro </label>
                          <Field
                            type="text"
                            name="logradouro"
                            className={styles.input_style}
                          />
                          {errors.logradouro && touched.logradouro ? (
                            <span className={styles.alertError}>
                              {errors.logradouro}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={1}>
                          <label> Número </label>
                          <Field type="number" name="numero" />
                          {errors.numero && touched.numero ? (
                            <span className={styles.alertError}>
                              {errors.numero}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label> Complemento </label>
                          <Field
                            type="text"
                            name="complemento"
                            className={styles.input_style}
                          />
                          {errors.complemento && touched.complemento ? (
                            <span className={styles.alertError}>
                              {errors.complemento}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>

                      <Grid>
                        <Col size={5}>
                          <label> Bairro </label>
                          <Field
                            type="text"
                            name="bairro"
                            className={styles.input_style}
                          />
                          {errors.bairro && touched.bairro ? (
                            <span className={styles.alertError}>
                              {errors.bairro}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={5}>
                          <label> Cidade </label>
                          {/* <Field component="select" name="cidade">
                            <option value="">Selecione</option>
                            {cidade.map((values) => (
                              <option
                                key={values?.id_cidade}
                                value={values?.id_cidade}
                              >
                                {values?.cidade}
                              </option>
                            ))}
                          </Field> */}
                          <Field
                            name="cidade"
                            component={SelectSearch}
                            options={cidade.map((values) => ({
                              value: values?.IDCidade,
                              label: values?.Cidade,
                            }))}
                          />
                          {errors.cidade && touched.cidade ? (
                            <span className={styles.alertError}>
                              {errors.cidade}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> UF </label>
                          <Field
                            type="text"
                            name="uf"
                            className={styles.input_style}
                          />
                          {errors.uf && touched.uf ? (
                            <span className={styles.alertError}>
                              {errors.uf}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>

                      {/*inicio novos campos campos */}
                      <Grid>
                        {/* <Col size={2}>
                      <label> Seguimento </label>
                      <Field component="select" type="text" name="seguimento">
                        <option value="">Selecione</option>
                        <option
                          value="oleo"
                        >
                          ÓLEO
                        </option>
                      </Field>
                    </Col> */}
                        <Col size={2}>
                          <label> Tipo Contrapartida </label>
                          {/* <Field component="select" name="tipoContrapartida">
                            <option value="">Selecione</option>
                            {tipoContrapartida.map((values) => (
                              <option
                                key={values?.IDTipoContrapartida}
                                value={values?.IDTipoContrapartida}
                              >
                                {values?.TipoContrapartida}
                              </option>
                            ))}
                          </Field> */}
                          <Field
                            component={SelectSearch}
                            name="tipoContrapartida"
                            options={tipoContrapartida.map((values) => ({
                              value: values?.IDTipoContrapartida,
                              label: values?.TipoContrapartida,
                            }))}
                          />
                          {errors.tipoContrapartida &&
                          touched.tipoContrapartida ? (
                            <span className={styles.alertError}>
                              {errors.tipoContrapartida}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> Forma De Pagamento </label>
                          {/* <Field component="select" name="pagamento">
                            <option value="">Selecione</option>
                            {formaDePagamento.map((values) => (
                              <option key={values?.Id} value={values?.Id}>
                                {values?.TipoPagamento}
                              </option>
                            ))}
                          </Field> */}
                          <Field
                            name="pagamento"
                            component={SelectSearch}
                            options={formaDePagamento.map((values) => ({
                              value: values?.Id,
                              label: values?.TipoPagamento,
                            }))}
                          />
                          {errors.pagamento && touched.pagamento ? (
                            <span className={styles.alertError}>
                              {errors.pagamento}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> Valor/Kg </label>
                          <Field name="valorKgContrapartida">
                            {({ field }) => (
                              <input type="number" step="any" {...field} />
                            )}
                          </Field>
                          {errors.valorKgContrapartida &&
                          touched.valorKgContrapartida ? (
                            <span className={styles.alertError}>
                              {errors.valorKgContrapartida}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={6}>
                          <label> Grupo </label>
                          {/* <Field component="select" name="grupo">
                            <option value="">Selecione</option>
                            {grupo.map((values) => (
                              <option
                                key={values?.id_grupo}
                                value={values?.id_grupo}
                              >
                                {values?.descricao_grupo}
                              </option>
                            ))}
                          </Field> */}
                          <Field
                            name="grupo"
                            component={SelectSearch}
                            options={grupo.map((values) => ({
                              value: values?.id_grupo,
                              label: values?.descricao_grupo,
                            }))}
                          />
                          {errors.grupo && touched.grupo ? (
                            <span className={styles.alertError}>
                              {errors.grupo}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>
                      <Box border={1} padding={1} marginY={1}>
                        <Grid>
                          <Col size={3}>
                            <label>Banco</label>
                            <Field name="banco">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                          <Col size={3}>
                            <label>Nome favorecido</label>
                            <Field name="favorecido">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                          <Col size={3}>
                            <label> Tipo Pessoa</label>
                            <Field
                              name="tipoPessoa"
                              component={SelectSearch}
                              options={[{ value: 1, label: "exemplo1" }]}
                            />
                          </Col>
                          <Col size={3}>
                            <label>CPF/CNPJ</label>
                            <Field name="cpfCnpjBanco">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                        </Grid>
                        <Grid>
                          <Col size={3}>
                            <label> Tipo Conta</label>
                            {/* <Field component="select" name="tipoConta">
                              <option value="">Selecione</option>
                              <option key={1} value={1}>
                                Conta Corrente
                              </option>
                              <option key={2} value={2}>
                                Conta Salário
                              </option>
                            </Field> */}
                            <Field
                              name="tipoConta"
                              component={SelectSearch}
                              options={[
                                { value: 1, label: "Conta Salário" },
                                { value: 2, label: "Conta Corrente" },
                              ]}
                            />
                          </Col>
                          <Col size={3}>
                            <label>Agência</label>
                            <Field name="agencia">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                          <Col size={3}>
                            <label>Conta</label>
                            <Field name="numeroConta">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                        </Grid>
                        <Grid>
                          <Col size={3}>
                            <label> Tipo Chave Pix</label>
                            <Field
                              name="tipoChavePix"
                              component={SelectSearch}
                              options={tipoPix?.map((values) => ({
                                label: values?.TipoChavePix,
                                value: values?.IdTipoChavePix,
                              }))}
                            />
                          </Col>
                          <Col size={3}>
                            <label>Número pix</label>
                            <Field name="numeroPix">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className={styles.input_style}
                                  {...field}
                                />
                              )}
                            </Field>
                          </Col>
                          {/* <Col size={2}>
                            <Button
                              type="button"
                              className={styles.button_conta}
                              onClick={() => adicionaBanco(values)}
                              disabled={isSubmitting || blockBtnBanco}
                            >
                              Salvar Conta
                            </Button>
                          </Col> */}
                        </Grid>
                      </Box>
                      <Grid>
                        <Col size={2}>
                          <label> Origem </label>
                          <Field
                            component={SelectSearch}
                            name="origem"
                            options={origem.map((values) => ({
                              value: values?.id,
                              label: values?.origem,
                            }))}
                          />
                          {errors.origem && touched.origem ? (
                            <span className={styles.alertError}>
                              {errors.origem}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label> Preferência de contato </label>
                          <Field
                            component={SelectSearch}
                            name="preferenciaContato"
                            options={preferenciaContato.map((values) => ({
                              value: values?.IdPreferenciaContato,
                              label: values?.PreferenciaContato,
                            }))}
                          />
                          {errors.preferenciaContato &&
                          touched.preferenciaContato ? (
                            <span className={styles.alertError}>
                              {errors.preferenciaContato}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={5}>
                          <label>E-mail</label>
                          <Field name="email">
                            {({ field }) => (
                              <input
                                type="text"
                                className={styles.input_style}
                                {...field}
                              />
                            )}
                          </Field>
                        </Col>
                      </Grid>

                      <div className={styles.container_observacao}>
                        <div style={{ width: "100%" }}>
                          <Grid>
                            <Col size={6}>
                              <label>Analista</label>
                              <Field name="analista">
                                {({ field }) => (
                                  <input
                                    type="text"
                                    className={styles.input_style}
                                    {...field}
                                  />
                                )}
                              </Field>
                              {errors.analista && touched.analista ? (
                                <span className={styles.alertError}>
                                  {errors.analista}
                                </span>
                              ) : null}
                            </Col>
                            <Col size={6}>
                              <label> Captação </label>
                              <Field
                                name="captacao"
                                component={SelectSearch}
                                options={captacao.map((values) => ({
                                  value: values?.id_usuario,
                                  label: values?.nome_usuario,
                                }))}
                              />
                              {errors.captacao && touched.captacao ? (
                                <span className={styles.alertError}>
                                  {errors.captacao}
                                </span>
                              ) : null}
                            </Col>
                          </Grid>
                          <Grid>
                            <Col size={6}>
                              <label>Nome Contato</label>
                              <Field name="nomeContato">
                                {({ field }) => (
                                  <input
                                    type="text"
                                    className={styles.input_style}
                                    {...field}
                                  />
                                )}
                              </Field>
                              {errors.nomeContato && touched.nomeContato ? (
                                <span className={styles.alertError}>
                                  {errors.nomeContato}
                                </span>
                              ) : null}
                            </Col>
                            <Col size={6}>
                              <label> Telefones </label>
                              <Field name="telefones">
                                {({ field }) => (
                                  <input
                                    type="text"
                                    className={styles.input_style}
                                    {...field}
                                  />
                                )}
                              </Field>
                              {errors.telefones && touched.telefones ? (
                                <span className={styles.alertError}>
                                  {errors.telefones}
                                </span>
                              ) : null}
                            </Col>
                          </Grid>
                        </div>
                        <Col style={{ width: "100%" }}>
                          <label> Observação </label>
                          <Field
                            component="textarea"
                            name="observacao"
                            className={styles.input_style}
                          ></Field>
                          {errors.observacao && touched.observacao ? (
                            <span className={styles.alertError}>
                              {errors.observacao}
                            </span>
                          ) : null}
                        </Col>
                      </div>
                      <Grid>
                        <Col size={3}>
                          <label> Usuário Criação </label>
                          <Field
                            component={SelectSearch}
                            name="usuarioCriacao"
                            options={captacao.map((values) => ({
                              value: values?.id_usuario,
                              label: values?.nome_usuario,
                            }))}
                            disabled
                          />
                        </Col>
                        <Col size={3}>
                          <label> Usuário alteração </label>
                          <Field
                            component={SelectSearch}
                            name="usuarioAlteracao"
                            options={captacao.map((values) => ({
                              value: values?.id_usuario,
                              label: values?.nome_usuario,
                            }))}
                            disabled
                          />
                        </Col>
                        <Col size={3}>
                          <label>Data de Criação</label>
                          <Field name="dataCriacao">
                            {({ field }) => (
                              <input
                                type="datetime-local"
                                {...field}
                                value={field.value?.slice(0, 16)}
                                disabled
                              />
                            )}
                          </Field>
                        </Col>
                        <Col size={3}>
                          <label>Data de Alteração</label>
                          <Field name="dataAlteracao">
                            {({ field }) => (
                              <input
                                type="datetime-local"
                                {...field}
                                value={field.value?.slice(0, 16)}
                                disabled
                              />
                            )}
                          </Field>
                        </Col>
                      </Grid>

                      {/*  
                <table>
                  <thead>
                    <tr>
                      <th colSpan="6"> Contato </th>
                    </tr>
                    <tr>
                      <th style={{width: 10}}> Ação </th>
                      <th> Nome contato </th>
                      <th style={{width: 10}}> DDD </th>
                      <th> Telefone </th>
                      <th> Tipo </th>
                      <th> Operadora </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>
                          <Link to="#">
                            <i className="fas fa-pencil-alt"></i>
                          </Link>
                        </span>{' '}
                        <br />
                        <span>
                          <Link to="#">
                            <i className="fas fa-trash-alt"></i>
                          </Link>
                        </span>
                      </td>
                      <td>Augusto</td>
                      <td>+11</td>
                      <td>1111-2222</td>
                      <td>1</td>
                      <td>Vivo</td>
                    </tr>
                  </tbody>
                </table>
              */}
                    </>
                  )}
                </TabPanel>
                <TabPanel>
                  <Coletas />
                </TabPanel>
                <TabPanel>
                  <Grid>
                    <Col size={2}>
                      <label> Emite MTR </label>
                      <Field
                        component={SelectSearch}
                        name="emitemtr"
                        options={[
                          { value: 0, label: "NÂO" },
                          { value: 1, label: "SIM" },
                        ]}
                      />
                      {errors.emitemtr && touched.emitemtr ? (
                        <span className={styles.alertError}>
                          {errors.emitemtr}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={2}>
                      <label> Entidade MTR </label>
                      {/* <Field name="entidademtr" component="select">
                        {entidade.map((values) => (
                          <option key={values?.ID} value={values?.ID}>
                            {values?.NomeEntidadeMtr}
                          </option>
                        ))}
                      </Field> */}
                      <Field
                        name="entidademtr"
                        component={SelectSearch}
                        options={entidade.map((values) => ({
                          value: values?.ID,
                          label: values?.NomeEntidadeMtr,
                        }))}
                      />
                      {errors.entidadeMTR && touched.entidadeMTR ? (
                        <span className={styles.alertError}>
                          {errors.entidadeMTR}
                        </span>
                      ) : null}
                    </Col>

                    <Col size={2}>
                      <label> Login </label>
                      <Field type="text" name="login" />
                      {errors.login && touched.login ? (
                        <span className={styles.alertError}>
                          {errors.login}
                        </span>
                      ) : null}
                    </Col>

                    <Col size={2}>
                      <label> Senha </label>
                      <Field type="password" name="senha" />
                      {errors.senha && touched.senha ? (
                        <span className={styles.alertError}>
                          {errors.senha}
                        </span>
                      ) : null}
                    </Col>

                    <Col size={2}>
                      <label> Unidade </label>
                      <Field
                        type="text"
                        name="unidade"
                        className={styles.input_style}
                      />
                      {errors.unidade && touched.unidade ? (
                        <span className={styles.alertError}>
                          {errors.unidade}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                </TabPanel>
                <TabPanel>
                  <Ligacao />
                </TabPanel>
                <TabPanel>
                  <Relacionamento />
                </TabPanel>
                <TabPanel>
                  <Materiais />
                </TabPanel>
              </Tabs>
              <section className={styles.section_button}>
                <Button
                  title="Salvar"
                  type="submit"
                  disabled={isSubmitting || block}
                />
                <Button
                  color="secondary"
                  title="Voltar"
                  onClick={() => {
                    navigate("/usina/local");
                  }}
                  type="button"
                  disabled={isSubmitting}
                />
              </section>
              {isSubmitting && (
                <div className={styles.loading}>
                  <Loading />
                </div>
              )}
            </Form>
          )}
        </Formik>
      </section>
      <Modal
        width="500px"
        height="200px"
        titleModal="Contrapartida"
        display={openModalBrinde}
        onClick={setOpenModalBrinde}
      >
        <ModalBrinde
          setOpenModalBrinde={setOpenModalBrinde}
          adicionaBrindeAPI={adicionaBrindeAPI}
          adicionaBrindeLocalmente={adicionaBrindeLocalmente}
        />
      </Modal>
    </Container>
  );
}
